import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaTachometerAlt, FaHome, FaInfoCircle, FaCogs,
  FaImages, FaUsers, FaComments, FaHandshake,FaRoad 
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ sidebarOpen, closeSidebar }) => {
  const menuItems = [
    { path: '/admin', icon: <FaTachometerAlt />, label: 'Dashboard' },
    { path: '/admin/home', icon: <FaHome />, label: 'Home Page' },
    { path: '/admin/about', icon: <FaInfoCircle />, label: 'About Us' },
    { path: '/admin/services', icon: <FaCogs />, label: 'Our Businesses' },
    { path: '/admin/gallery', icon: <FaImages />, label: 'Gallery' },
    { path: '/admin/team', icon: <FaUsers />, label: 'Leadership Team' },
    { path: '/admin/testimonials', icon: <FaComments />, label: 'Testimonials' },
    { path: '/admin/partners', icon: <FaHandshake />, label: 'Partners' },
    { path: '/admin/journey', icon: <FaRoad />, label: 'Our Journey' },
  ];

  return (
    <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/Sarwa Logo.png" alt="Sarwa Group Logo" className="sidebar-logo-img" />
          {sidebarOpen && (
            <div className="logo-text">
              <strong>SARWA GROUP</strong>
              <span>HOLDING HQ</span>
            </div>
          )}
        </div>
      </div>

      <div className="sidebar-menu-wrapper">
        {menuItems.map((item, i) => (
          <NavLink
            key={i}
            to={item.path}
            end={item.path === '/admin'}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            title={item.label}
            onClick={closeSidebar}
          >
            <span className="link-icon">{item.icon}</span>
            {sidebarOpen && <span className="link-label">{item.label}</span>}
          </NavLink>
        ))}
      </div>

      {sidebarOpen && (
        <div className="sidebar-footer">
          <p>© {new Date().getFullYear()} Sarwa Group</p>
          <p>Console v2.0</p>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;